<template>
  <div id="navbar_pantalla" class="w3-container w3-row" v-if="isAuthenticated && currentSubmenuActions">
    <div id="navbar_pantalla_submenu" class="w3-row">
      <div class="navbar_pantalla_item" v-for="item in currentSubmenu" :key="item.id">
        <!-- internal link -->
        <router-link v-if="item.contextPath"
          :to="{ path: item.parentContextPath + item.contextPath }"
          v-tooltip="{content: item.name, delay: { show: 400, hide: 100 }}"
        >
          <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
        </router-link>

        <!-- external link -->
        <a v-else-if="item.externalUrl"
          :href="item.externalUrl"
          target="_blank"
          v-tooltip="{content: item.name, delay: { show: 400, hide: 100 }}"
        >
          <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
        </a>
      </div>
    </div>
    <div id="navbar_pantalla_submenu_actions" class="w3-row">
      <div class="navbar_pantalla_item" v-for="item in currentSubmenuActions" :key="item.id">
        <div>
          <!-- internal link -->
          <router-link v-if="item.contextPath"
            :to="{ path: item.parentContextPath + item.contextPath }"
          >
            <div>
              <span> {{ item.name }} </span>
              <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
            </div>
          </router-link>

          <!-- external link -->
          <a v-else-if="item.externalUrl"
            :href="item.externalUrl"
            target="_blank"
          >
            <div>
              <span> {{ item.name }} </span>
              <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'

export default {
  name: 'actions-header',
  data () {
    return {
      currentSubmenu: [],
      currentSubmenuActions: []
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    newCurrentSubmenu () {
      return getCurrentContentMenu(
        this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT_ID}`],
        this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`],
        null
      )
    }
  },
  watch: {
    newCurrentSubmenu (currentMenu) {
      if (currentMenu) {
        this.currentSubmenu = currentMenu.subMenu
        var newCurrentSubmenu = getCurrentContentMenu(this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT_ID}`], this.currentSubmenu, null)
        if (newCurrentSubmenu) {
          this.currentSubmenuActions = newCurrentSubmenu.subMenu
        } else {
          this.currentSubmenuActions = null
        }
      }
    }
  }
}

function getCurrentContentMenu (currentContentId, menu, parentMenu) {
  var currentMenu = null
  if (menu) {
    menu.map((item) => {
      if (item.id === currentContentId) {
        if (parentMenu === null) {
          currentMenu = item
        } else {
          currentMenu = parentMenu
        }
      }
      if (item.subMenu) {
        var childCurrentMenu = getCurrentContentMenu(currentContentId, item.subMenu, item)
        if (childCurrentMenu) {
          if (parentMenu === null) {
            currentMenu = childCurrentMenu
          } else {
            currentMenu = parentMenu
          }
        }
      }
    })
  }
  return currentMenu
}
</script>

<style lang="scss">
#content #navbar_pantalla {
  width: 100%;
  height: 56px;
  background-color: #f8f8f8;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease-in;

  #navbar_pantalla_submenu {
    display: flex;
    flex-flow: wrap;
    float: left;
    height: 100%;

    .navbar_pantalla_item {
      position: relative;
      width: 65px;
      height: 100%;
      margin: 0;

      a {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #e5e5e5;
        text-align: center;
        transition: background-color 0.2s ease-in;

        i {
          position: absolute;
          top: 24%;
          left: 31%;
          font-size: 24px;
          color: #342d38;
        }
      }

      a.link-active,
      a:hover {
        background-color: white;
        transition: background-color 0.3s ease-in;
      }
    }
  }

  #navbar_pantalla_submenu_actions {
    position: relative;
    height: 100%;
    display: flex;
    flex-flow: wrap;
    float: right;
    margin-right: 16px;

    .navbar_pantalla_item {
      float: right;
      cursor: pointer;

      >div {
        height: 100%;
        width: 100%;

        a {
          text-decoration: none;
          padding: 0 18px;
          width: 100%;
          height: 100%;
          display: block;
          transition: background-color 0.2s ease-in;
          background-color: #e5e5e5;

          >div {
            padding-top: 15px;

            span {
              font-family: Capriola;
              font-size: 13px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              text-align: right;
              color: #4599a4;
            }

            i {
              font-size: 20px;
              margin-left: 5px;
              vertical-align: middle;
              color: #ff7643;
            }
          }
        }

        a.link-active,
        a:hover {
          background-color: white;
          transition: background-color 0.3s ease-in;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appHeader/actionsHeader.vue